/**
 * Gallery Module
 * Handles gallery filtering and lightbox functionality
 */

export function initGallery() {
    const filterButtons = document.querySelectorAll('.filter-btn');
    const galleryItems = document.querySelectorAll('.gallery-item');
    const galleryLinks = document.querySelectorAll('.gallery-item a[data-lightbox]');

    // Filter functionality
    if (filterButtons.length > 0 && galleryItems.length > 0) {
        filterButtons.forEach(button => {
            button.addEventListener('click', () => {
                const filter = button.dataset.filter;

                // Update active button
                filterButtons.forEach(btn => btn.classList.remove('active'));
                button.classList.add('active');

                // Filter items
                galleryItems.forEach(item => {
                    const category = item.dataset.category;
                    if (filter === 'all' || category === filter) {
                        item.classList.remove('hidden');
                    } else {
                        item.classList.add('hidden');
                    }
                });
            });
        });
    }

    // Lightbox functionality
    if (galleryLinks.length > 0) {
        const lightbox = createLightbox();
        document.body.appendChild(lightbox);

        const lightboxImg = lightbox.querySelector('.lightbox-content img');
        const closeBtn = lightbox.querySelector('.lightbox-close');
        const prevBtn = lightbox.querySelector('.lightbox-prev');
        const nextBtn = lightbox.querySelector('.lightbox-next');

        let currentIndex = 0;
        const visibleLinks = () => Array.from(galleryLinks).filter(link =>
            !link.closest('.gallery-item').classList.contains('hidden')
        );

        // Open lightbox
        galleryLinks.forEach((link, index) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const visible = visibleLinks();
                currentIndex = visible.indexOf(link);
                if (currentIndex >= 0) {
                    showLightbox(visible[currentIndex].href);
                }
            });
        });

        // Close lightbox
        closeBtn.addEventListener('click', closeLightbox);
        lightbox.addEventListener('click', (e) => {
            if (e.target === lightbox) {
                closeLightbox();
            }
        });

        // Navigation
        prevBtn.addEventListener('click', () => {
            const visible = visibleLinks();
            currentIndex = (currentIndex - 1 + visible.length) % visible.length;
            showLightbox(visible[currentIndex].href);
        });

        nextBtn.addEventListener('click', () => {
            const visible = visibleLinks();
            currentIndex = (currentIndex + 1) % visible.length;
            showLightbox(visible[currentIndex].href);
        });

        // Keyboard navigation
        document.addEventListener('keydown', (e) => {
            if (!lightbox.classList.contains('active')) return;

            if (e.key === 'Escape') {
                closeLightbox();
            } else if (e.key === 'ArrowLeft') {
                prevBtn.click();
            } else if (e.key === 'ArrowRight') {
                nextBtn.click();
            }
        });

        function showLightbox(imageSrc) {
            lightboxImg.src = imageSrc;
            lightbox.classList.add('active');
            document.body.style.overflow = 'hidden';
        }

        function closeLightbox() {
            lightbox.classList.remove('active');
            document.body.style.overflow = '';
        }
    }
}

function createLightbox() {
    const lightbox = document.createElement('div');
    lightbox.className = 'lightbox';
    lightbox.innerHTML = `
        <button class="lightbox-close" aria-label="Close lightbox">&times;</button>
        <button class="lightbox-nav lightbox-prev" aria-label="Previous image">&#8249;</button>
        <button class="lightbox-nav lightbox-next" aria-label="Next image">&#8250;</button>
        <div class="lightbox-content">
            <img src="" alt="Gallery image">
        </div>
    `;
    return lightbox;
}
